export const NETWORK_ERROR_MESSAGE =
  "Network error. Please check your connection and try again.";

function firstString(value: unknown): string | null {
  if (typeof value === "string" && value.trim()) return value.trim();
  if (Array.isArray(value)) {
    for (const v of value) {
      const found = firstString(v);
      if (found) return found;
    }
  }
  return null;
}

/**
 * Extracts the most useful human readable message from an API/axios error.
 * Prefers the backend's own message (plain text, `error`, `message`, `title`,
 * or the first validation error) and only reports a network error when the
 * request never received a response.
 */
export function parseApiError(
  error: unknown,
  fallback: string = "Something went wrong. Please try again."
): string {
  const anyErr = error as any;
  const response = anyErr?.response;

  if (response) {
    const data = response.data;
    const direct = firstString(data);
    if (direct) return direct;

    if (data && typeof data === "object") {
      const picked =
        firstString(data.error) ??
        firstString(data.message) ??
        firstString(data.Message) ??
        firstString(data.detail);
      if (picked) return picked;

      if (data.errors && typeof data.errors === "object") {
        const nested = firstString(Object.values(data.errors));
        if (nested) return nested;
      }
      const title = firstString(data.title);
      if (title) return title;
    }
    return `${fallback} (HTTP ${response.status})`;
  }

  if (anyErr?.request || anyErr?.code === "ERR_NETWORK") {
    return NETWORK_ERROR_MESSAGE;
  }

  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
